export const appendSearchParams = (url: string, searchParams: Record<string, string | null | undefined>): URL => {
  const newUrl = new URL(url)
  for (const [name, value] of Object.entries(searchParams)) {
    if (value) {
      newUrl.searchParams.append(name, value)
    }
  }
  return newUrl
}

export const getValidatedXundUrl = (inputUrl: string | null | undefined, defaultUrl: string): string => {
  let url: URL

  try {
    if (!inputUrl) throw new Error('Invalid URL')
    url = new URL(inputUrl)
    if (validateXundUrl(url)) {
      return cleanupUrl(url)
    } else {
      console.warn(`Invalid url given: ${url}, using default url`)
      throw new Error('Invalid URL')
    }
  } catch {
    return cleanupUrl(new URL(defaultUrl))
  }
}

const validateXundUrl = function (url: URL): boolean {
  return url.hostname.endsWith('.xund.solutions') || url.hostname === 'localhost'
}

const cleanupUrl = function (url: URL): string {
  return url.pathname === '/' ? url.origin : url.href
}

export const getAttr = (tag: HTMLScriptElement, name: string): string | null => {
  const urlParams = new URLSearchParams(document.location.search)
  const attrName = name.replace(/[A-Z]/g, (m: string) => `-${m.toLowerCase()}`)
  const attrValue = tag.getAttribute(attrName)
  if (attrValue) {
    return attrValue
  }

  const urlParamName = attrName === 'app-language' ? 'language' : name
  return urlParams.get(urlParamName)
}
